import React from 'react';
import { CustomerQueueItem } from './customer-queue-item';
import { CustomerQueue } from '../../../types/models/customer-queue';

interface CustomerQueuesProps {
  queues?: Array<CustomerQueue>;
}

export function CustomerQueues(props: CustomerQueuesProps) {
  return (
    <>
      {/* A label, not a link: /admin/providers/:id has no page in this app. */}
      {(props.queues ?? []).map((q) => (
        <span key={q.id} className="ui label">
          <CustomerQueueItem queue={q} />
        </span>
      ))}
    </>
  );
}
